export const LocalStorageKeys = {
  AuthToken: "AUTOM8N_AUTH_TOKEN",
  AdminAuthToken: "AUTOM8N_ADMIN_AUTH_TOKEN",
  OAUTH: "AUTOM8N_OAUTH",
  PendingRequest: "AUTOM8N_PENDING_REQUEST",
} as const;

export const AppConfig = {
  AppName: "Autom8n",
};
